import {SOPutStep} from '../../core/step/so-put-step';
import {StepCore} from './step.core';
import {SOGetStep} from '../../core/step/so-get-step';
import {FormField, SelectionOption} from 'lionheartland';
import {putStepFormFieldOptions} from './put-step-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePut} from 'lionheartland';
import {ProcessStepAssociationCore} from '../process-step-association/process-step-association.core';
import {SOGetProcessStepAssociation} from '../../core/process-step-association/so-get-process-step-association';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPutStep extends BasePut implements AdapterProtocol {
  formFieldOptions = Object.values(putStepFormFieldOptions);

  RequestClass = SOPutStep

  constructor(
    public entityCore: StepCore
  ) {
    super();
    if (putStepFormFieldOptions.processStepAssociations) {
      putStepFormFieldOptions.processStepAssociations.makeCore = true;
    }
    if (putStepFormFieldOptions.project) {
      putStepFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.selectedEntity.uid,
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('description'),
      this.getFormValueFromIdentifier('stepNumber'),
      [this.getFormValueFromIdentifier('processStepAssociations', SOGetProcessStepAssociation)],
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}